import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router";

import React, { useEffect } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { routePath } from "./constants/routePath";

import {
  Box,
  Drawer,
  Fab,
  Grid,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import Loader from "./common/loader";
import SideBar from "./common/sideBax";
import ShareElegantModal from "./common/shareElegantModal";
import Header from "./common/header";
import {
  GetUserApi,
  GetUserMenuApi,
  GetUserMenuAssociate,
  GetUserMenuHeaderApi,
  useBreakpoint,
} from "./utils/utils";

import {
  BusiReport,
  clearLoginSource,
  setActvieBussinessDetails,
  setAnalaticDisplay,
  setBarName,
  setBarSide,
  setbusinessChooseTab,
  setBussinessSideBar,
  setchangeRoll,
  // setchangeRoll,
  setCustomerManagmentDisplay,
  setfavProduct,
  setHeaderMenu,
  setSideBarMenu,
  setTableName,
  setUserDetail,
} from "./app/store/reducer";
import { useTheme } from "@emotion/react";
import SimpleSnackbar from "./common/Snackbar";

import MobileHeader from "./common/mobileHeader";
import { useState } from "react";
import Footer from "./common/Footer";

import {
  ensureAuthenticatedUserOrRedirectToLandingPage,
  footerRenderingAccordingToPages,
  halfSideBarRenderingAccordingToPages,
  handleHeaderLandingRenderingAccordingTopages,
  handleHeaderRenderingAccordingTopages,
  handleMobileHeaderRederingAccordingToPages,
  pageGridSizeAccordingToLocation,
} from "./utils/routeUtils";
import HalfSideBar from "./common/halfSideBar";
import { counterSellSetOnLastIndex, getSession } from "./utils/commonUtils";
import { RoutesSet } from "./utils/routeSet";
import { NavBar } from "./common/landingPage/navbar";
import { NavBoarContainer } from "./common/navBarContainer";
import { GetBussiness } from "./features/myBusiness/myBusinessApi";
import BussinessMangment from "./common/businessChategory";
import CustomerMangementbar from "./common/customerMangementBar";
import Analatic from "./common/analaticsBar";
import BillingBarSide from "./common/billingSide";
import NavbarDashboard from "./common/navBarDashboard";
import AnalaticSideBarT from "./common/sidebar/analatics";
import HelpModal from "./features/helpAndSupport/helpModal";
import SearchFilterModal from "./common/landingPage/searchFilterModal";
import LandingPage from "./features/landingPage/landingPage";
import AdminSidebar from "./features/companyLogin/adminSidebar";
import { MyBusinessAddApi } from "./features/userLogin/loginApi";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const menuLoginHeader = [
    {
      title: "Home",
    },
    {
      title: "About",
    },
  ];
  //console.log("menuLoginHeader ");

  const mobileNumner = useSelector((state) => state.reducer.mobileNumner);
  const [navbarSearchFilterOpen, setNavbarSearchFilterOpen] = useState(false);
  const manualNavigation = useSelector(
    (state) => state.reducer.manualNavigation,
  );

  useEffect(() => {
    //console.log("mobileNumner ", mobileNumner);
  }, [mobileNumner]);
  const [drawerShow, setDrawerShow] = useState(false);
  const [sideBarDrawer, setsideBarDrawer] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const barName = useSelector((state) => state.reducer.barName);
  const changeRoll = useSelector((state) => state.reducer.changeRoll);

  const favProduct = useSelector((state) => state.reducer.favProduct);
  // const =useSelector((state)=>state.reducer.BussinessMangment)
  const BussinessSideBar = useSelector(
    (state) => state.reducer.BussinessSideBar,
  );
  const customerManagmentDisplay = useSelector(
    (state) => state.reducer.customerManagmentDisplay,
  );
  const analaticDisplay = useSelector((state) => state.reducer.analaticDisplay);

  const billingSide = useSelector((state) => state.reducer.billingSide);

  useEffect(() => {
    //console.log("path name location true billiing ", billingSide);
  }, [billingSide]);
  const [flag, setFlat] = useState({
    getData: false,
  });
  useEffect(() => {
    //console.log("userDetail ", userDetail);
    const token = sessionStorage.getItem("smbToken");

    if (Object.keys(userDetail).length > 0 && userDetail?.role !== "Admin") {
      if (!flag.getData) {
        if (userDetail.role === "Associate") return;
        getData();
        setFlat({ ...flag, getData: true });
      }
    }
    if (token === null && token === undefined) {
      sessionStorage.removeItem("smbToken");

      navigate("/");

      // Or if you are not using `useHistory`:
      // window.location.href = "/login";
    }
  }, [userDetail]);
  const tableName = useSelector((state) => state.reducer.tableName);
  const dispatch = useDispatch();

  const getData = async () => {
    if (userDetail.role === "Associate") return;

    await GetBussiness().then((res) => {
      //console.log("es.data.data[0] ", res.data.data[0]);

      // if (userDetail?.role == "Admin") {
      //   dispatch(setchangeRoll("admin"));
      // } else {
      //   if (userDetail?.appMenu == "Biller") {
      //     dispatch(setchangeRoll("dashboard"));
      //   }
      // }
      if (changeRoll === null) return;

      if (userDetail?.role === "Admin") {
        dispatch(setchangeRoll("admin"));
      } else if (userDetail?.appMenu === "Biller") {
        dispatch(setchangeRoll("dashboard"));
      }
      dispatch(
        setUserDetail({
          ...userDetail,
          uploadedLogo: res.data.data[0]?.logoPath,
        }),
      );

      dispatch(setActvieBussinessDetails(res.data.data[0]));

      // setMyBussinessData({
      //   ...res.data.data[0],
      //   mobileNumber: userDetail?.mobileNumber,
      // });
    });
  };

  // const getUser = async () => {
  //   await GetUserApi()
  //     .then(async (res) => {
  //       let tmpChangeBus = { ...res.data.data };
  //       // businessLineCode
  //       if (userDetail?.role == "Admin") {
  //         dispatch(setchangeRoll("admin"));
  //       } else if (userDetail?.appMenu == "Biller") {
  //         dispatch(setchangeRoll("dashboard"));
  //       }

  //       // dispatch(setUserDetail({ ...tmpChangeBus, businessLineCode: "CB" }));
  //       dispatch(setUserDetail({ ...tmpChangeBus, businessLineCode: "RE" }));

  //       await GetUserMenuApi(
  //         res.data.data.businessLineId,
  //         res.data.data.languageCode,
  //       )
  //         .then((res) => {
  //           //console.log("businessLineId ", res.data.data.mainMenu);
  //           dispatch(setSideBarMenu(res.data.data.hamburger));
  //         })
  //         .catch((err) => {
  //           console.error("res ", err);
  //         });

  //       await GetUserMenuHeaderApi(
  //         res.data.data.businessLineId,
  //         res.data.data.languageCode,
  //       )
  //         .then((res) => {
  //           //console.log("businessLineId ", res.data.data.mainMenu);

  //           // //console.log("res.data.data.mainMenu ", res.data.data.mainMenu);
  //           let data = res.data.data.mainMenu;
  //           // //console.log("index header ss", counterSellSetOnLastIndex(data));
  //           dispatch(setHeaderMenu(counterSellSetOnLastIndex(data)));
  //         })
  //         .catch((err) => {
  //           console.error("res ", err);
  //         });
  //     })
  //     .catch((err) => {
  //       console.error("res ", err);
  //     });
  // };

  const loginSource = useSelector((state) => state.reducer.loginSource);

  const getUser = async () => {
    try {
      const res = await GetUserApi();
      const user = res.data.data;

      dispatch(setUserDetail({ ...user, businessLineCode: "RE" }));

      // role handling
      if (user?.role === "Admin") {
        dispatch(setchangeRoll("admin"));
      } else if (user?.appMenu === "Biller") {
        dispatch(setchangeRoll("dashboard"));
      }

      if (loginSource === "business" && user?.isFirstLogin === true) {
        await MyBusinessAddApi({ businessLineId: 10 });

        const updatedRes = await GetUserApi();
        const updatedUser = updatedRes.data.data;

        dispatch(setUserDetail({ ...updatedUser, businessLineCode: "RE" }));

        if (updatedUser?.appMenu === "Biller") {
          dispatch(setchangeRoll("dashboard"));
          navigate(routePath.DASHBOARD);
        }

        dispatch(clearLoginSource());
        return;
      }

      if (userDetail.role !== "Associate") return;
      // menus
      await GetUserMenuApi(user.businessLineId, user.languageCode).then(
        (res) => {
          dispatch(setSideBarMenu(res.data.data.hamburger));
        },
      );
      if (userDetail.role !== "Associate") return;
      await GetUserMenuHeaderApi(user.businessLineId, user.languageCode).then(
        (res) => {
          dispatch(
            setHeaderMenu(counterSellSetOnLastIndex(res.data.data.mainMenu)),
          );
        },
      );
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (userDetail.role !== "Associate") {
      if (userDetail?.businessLineId && userDetail?.languageCode) {
        GetUserMenuHeaderApi(
          userDetail.businessLineId,
          userDetail.languageCode,
        ).then((res) => {
          dispatch(
            setHeaderMenu(counterSellSetOnLastIndex(res.data.data.mainMenu)),
          );
        });
      }
    } else {
      GetUserMenuAssociate().then((res) => {
        dispatch(
          setHeaderMenu(counterSellSetOnLastIndex(res.data.data)),
        );
      });
    }
  }, [userDetail]);

  useEffect(() => {
    if (!userDetail?.appMenu) return;
    if (manualNavigation) return;
    if (userDetail.role === "Admin") {
      // navigate(routePath.ADMIN_DASHBOARD);
    } else if (userDetail.appMenu === "Biller") {
      navigate(routePath.DASHBOARD);
    } else {
      navigate(routePath.LANDINGPAGE);
    }
  }, [userDetail?.appMenu]);
// useEffect(() => {
//   if (!userDetail?.appMenu) return;
//   if (manualNavigation) return;

//   // ✅ only redirect if user is at root
//   if (location.pathname === "/") {
//     if (userDetail.role === "Admin") {
//       navigate(routePath.ADMIN_DASHBOARD);
//     } else if (userDetail.appMenu === "Biller") {
//       navigate(routePath.DASHBOARD);
//     } else {
//       navigate(routePath.LANDINGPAGE);
//     }
    
//   }
// }, [userDetail?.appMenu]);

  function isObjectEmpty(obj) {
    return Object.entries(obj).length === 0;
  }
  useEffect(() => {
    const token = sessionStorage.getItem("smbToken");
    // if ( token === null &&
    //   location.pathname !== "/login" &&
    //   location.pathname !== routePath.LANDINGPAGERESTORENT &&
    //   location.pathname !== routePath.LANDINGPAGECOUNTERTOKEN &&
    //   location.pathname !== routePath.LANDINGPAGEMONTHLYBILL &&
    //   location.pathname !== routePath.LANDINGPAGEFRANCHISE
    //   // ensureAuthenticatedUserOrRedirectToLandingPage(token, location, routePath)
    // ) {
    //   // navigate(routePath.LANDINGPAGE);
    //   return;
    // }
  }, []);

  const notApplyAuthRouting = {
    homepage: 1,
    salon: 1,
    details: 1,
    admin: 1,
    otpforget: 1,
    home: 1,
    ServicesList: 1,
    ReviewAndRating: 2,
    LANDINGPAGE: 1,
    detail: 1,
    REGISTRATION: 1,
    otp: 1,
    setMpin: 1,
    login: 1,
    appoinment: 1,
    otpappoinment: 1,
    fav: 1,
    privacyPolicy: 1,
    termsOfService: 1,
    getUserOffer: 1,
    services: 1,
    "assistant-login": 1,
    profile: 1,
    jobs: 1,
    apply: 1,
    myjobprofile: 1,
    editprofile: 1,
    jobfilter: 1,
    courses: 1,
    coursedetails: 1,
    franchiseList: 1,
    customerlogin: 1,
    whatIsElegantprime: 1,
    coursedetails: 1,
    instituteInfo: 1,
    franchiseDetails: 1,
  };

  const customerRoute = {
    fav: 1,
    appoinment: 1,
    detail: 1,
    ReviewAndRating: 2,
    services: 1,
    home: 1,
    ServicesList: 1,
    homepage: 1,
    salon: 1,
    details: 1,
    profile: 1,
    jobs: 1,
    apply: 1,
    myjobprofile: 1,
    editprofile: 1,
    jobfilter: 1,
    coursedetails: 2,
    instituteInfo: 1,
    franchiseDetails: 1,
  };
  const pageAccordingUserType = {
    Buyer: {
      ...customerRoute,
    },
    customer: {
      ...customerRoute,
    },
    adminPage: {
      advertisement: 1,
      recharge: 1,
      "recharge-report": 1,
      offers: 1,
      "user-profile-list": 1,
      "reports-tab": 1,
    },
    Biller: {
      // ...customerRoute,
      bulkService: 1,
      advertice: 1,
      dashboard: 1,
      employeeInfo: 1,
      employeePayroll: 1,
      homepage: 1,
      otpforget: 1,
      paymentStruct: 1,
      appoinmentDashboard: 1,
      REGISTRATION: 1,
      otpappoinment: 1,
      otp: 1,
      setMpin: 1,
      userprofile: 1,
      restorant: 1,
      inventory: 1,
      // fav: 1,
      token: 1,
      monthlybill: 1,
      franchise: 1,
      login: 1,
      "assistant-login": 1,
      advancepayment: 1,
      shareMessage: 1,
      countersale: 1,
      countersellbilling: 1,
      myprofile: 1,
      myBusiness: 1,
      tablemaster: 1,
      customerInformation: 1,
      updatebills: 1,
      itemServices: 1,
      "table-section": 1,
      "item-categories": 1,
      associatedUsers: 1,
      "payament-receipt": 1,
      outstandingReport: 1,
      "mobil-emenu-Page": 1,
      "smb-account-reacharge": 1,
      "item-wise-sale": 1,
      reports: 1,
      stocks: 1,
      purchase: 1,
      expence: 1,
      "help-support": 1,
      "reset-mpin": 1,
      setting: 1,
      "rate-change": 1,
      "cash-counter-sale": 1,
      "kyc-process": 1,
      privacyPolicy: 1,
      termsOfService: 1,
      addOffers: 1,
      getUserOffer: 1,
      salary: 1,
      home: 1,
      homepage: 1,
      // salon: 1,
      details: 1,
      profile: 1,
      employeeAttendance: 1,
      purchaseManagement: 1,
      shareEmployeeProfile: 1,
      sharemessagecontainer: 1,
      shareMessage: 1,
      bulkMessage: 1,
      bulkService: 1,
      shareratecart: 1,
      "account-recharge": 1,
      printerSetting: 1,
      myinstitute: 1,
      enquiries: 1,
      jobhiringpost: 1,
      jobfilter: 1,
      myfranchise: 1,
      whiteLables: 1,
      // instituteInfo: 1,
      // employeeadvancepaymentreport :1
    },
  };
  const bussinessMangementMenu = useSelector(
    (state) => state.reducer.bussinessMangementMenu,
  );

  const customerChategory = useSelector(
    (state) => state.reducer.customerChategory,
  );
  const adminCategory = useSelector((state) => state.reducer.adminCategory);
  const adverticement = useSelector((state) => state.reducer.adverticement);
  const UserProfile = useSelector((state) => state.reducer.UserProfile);
  const Recharge = useSelector((state) => state.reducer.Recharge);
  const Support = useSelector((state) => state.reducer.Support);

  const analatics = useSelector((state) => state.reducer.analatics);
  const billerMenu = useSelector((state) => state.reducer.billerMenu);

  // ....token
  const getToken = () => {
    const token = sessionStorage.getItem("smbToken");
    // const currentPath = location.pathname.split("/").pop(); // get last segment
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const secondLastSegment =
      pathSegments.length > 1 ? pathSegments[pathSegments.length - 2] : null;
    const lastSegment = pathSegments[pathSegments.length - 1];
    const currentPath = secondLastSegment || lastSegment;

    if (notApplyAuthRouting[currentPath]) {
      return true;
    }

    if (!token || token === "null" || token === "undefined") {
      navigate(routePath.LANDINGPAGE);
      return false;
    }

    return true;
  };
  const both = {
    ServicesList: 1,
  };
  // const

  useEffect(() => {
    //console.log("route tttttt   ", barName);
  }, [barName]);
  const redirectContinuousPage = async () => {
    await getSession("nextPage", async (data) => {
      //console.log("nextPage data", routePath[data]);

      if (location.pathname == "/") {
        //console.log("navigate data", userDetail?.appMenu, " ", changeRoll);
        // //console.log("navigate data",userDetail?.appMenu)
        if (userDetail?.appMenu !== "Biller" || changeRoll !== "dashboard") {
        }
        if (userDetail?.appMenu == "Biller" && changeRoll == "dashboard") {
        }
      }
    });
  };

  const keyCheck = (key) => {
    if (notApplyAuthRouting[key]) {
      return notApplyAuthRouting[key];
    } else {
      const key =
        location.pathname.split("/")[location.pathname.split("/").length - 2];
      return notApplyAuthRouting[key];
    }
  };
  const checkIsCustomer = (route) => {
    //console.log(
    //   "checkIsCustomer userDetail",
    //   userDetail?.appMenu,
    //   " ",
    //   changeRoll,
    // );

    // userDetail?.role==""
    let userType = userDetail?.appMenu;
    if (changeRoll == "admin") {
      userType = "adminPage";
    }
    if (userType == "Biller" && changeRoll == "customer") {
      userType = "Buyer";
    } else if (userType == "Biller" && changeRoll == "dashboard") {
      userType = "Biller";
    } else {
    }
    if (pageAccordingUserType[userType][route]) {
      return pageAccordingUserType[userType][route];
    } else {
      const key =
        location.pathname.split("/")[location.pathname.split("/").length - 2];
      return pageAccordingUserType[userType][key];
    }
  };

  const sideBarRenderCallback = {
    analatic: (val) => {
      setAnalaticDisplay(val);
    },
    bussinessMangment: (val) => {
      setBussinessSideBar(val);
    },
    CustomerMangment: (val) => {
      setCustomerManagmentDisplay(val);
    },
    billing: (val) => {
      setBarSide(val);
    },
  };

  const routeObj = {
    analatic: [
      ...analatics,
      {
        route: routePath.ADVERTICE,
      },
      ...BusiReport.map((ele) => {
        return {
          ...ele,
          route: ele.routePath,
        };
      }),
    ],
    bussinessMangment: bussinessMangementMenu,
    CustomerMangment: customerChategory,
    billing: billerMenu,
    // adminCategory: adminCategory,
    adverticement: adverticement,
    UserProfile: UserProfile,
    Recharge: Recharge,
    Support: Support,
  };
  const sideBarRenderHandler = (route) => {
    let val = "";
    Object.keys(routeObj).forEach((key, index) => {
      //console.log("route route=== hander ", index, " ", routeObj[key]);

      routeObj[key].forEach((ele, ind) => {
        if (route == ele.route || ele.route?.includes(key)) {
          //console.log("route ttttt", routeObj[key]);
          val = key;
        }
        //console.log(key, "route route=== hander dd", route, " ", ele.route);
      });
    });
    return val ?? barName;
  };
  useEffect(() => {
    const token = sessionStorage.getItem("smbToken");

    const key =
      location.pathname.split("/")[location.pathname.split("/").length - 1];
    // location.pathname.split("/")[location.pathname.split("/").length - 2]
    // if(userDetail &&)
    // //console.log("called return ", key);

    getSession("favProduct", (data) => {
      // //console.log("favprod ", data);

      let obj = {};
      if (data) {
        obj = JSON.parse(data);
        dispatch(setfavProduct(obj));
      }
      // obj[String(item.id)] = 1;

      //  obj[item.id]=1
      // //console.log("favprod first arr ", key);

      // setSession("favProduct", obj, () => {});

      // }
    });

    if (
      (keyCheck(key) && Object.keys(userDetail).length == 0) ||
      (Object.keys(userDetail).length !== 0 &&
        (key == "ServicesList" ||
          key == "appoinment" ||
          key == "otpappoinment" ||
          key == "fav"))
    ) {
      return;
    }
    // if (
    //   ensureAuthenticatedUserOrRedirectToLandingPage(token, location, routePath)
    // ) {
    //   navigate(routePath.LANDINGPAGE);
    //   return;
    // }
    if (token && location.pathname === routePath.LANDINGPAGE) {
      if (userDetail?.appMenu !== "Biller" || changeRoll !== "dashboard") {
        navigate(routePath.LANDINGPAGE);
      } else {
        // navigate(routePath.ADVERTICE);
      }
      return;
    }

    if (
      tableName === null &&
      location.pathname === routePath.COUNTERSELLBILLING
    ) {
      // navigate(routePath.COUNTERSELL);
      // return;
    }
    if (
      location.pathname === routePath.COUNTERSELL &&
      // userDetail?.businessLineCode !== "RE" &&
      userDetail?.businessLineCode
    ) {
      if (userDetail?.businessLineCode === "RE") {
        // navigate(routePath.COUNTERSELL);
      } else {
        dispatch(setTableName(userDetail?.name));
        // navigate(routePath.COUNTERSELLBILLING);
      }
    }
    // //console.log("tokendetail ", token, " ", userDetail);
    // if (token !== null && isObjectEmpty(userDetail)) {
    //   getUser();
    // }
    // if (token) {
    //   getUser();
    // }
    if (
      location.pathname === "/" ||
      location.pathname === routePath.SERVICESLIST
    ) {
      getToken();
    }

    // //console.log("path name ===", location.pathname, bussinessMangementMenu);
    bussinessMangementMenu.forEach((ele, index) => {
      if (ele.route == location.pathname) {
        //console.log("find it ", ele.route);
      }
    });
    customerChategory.forEach((ele, index) => {
      if (ele.route == location.pathname) {
        //console.log("find it ", ele.route);
      }
    });
    adminCategory.forEach((ele, index) => {
      if (ele.route == location.pathname) {
        //console.log("find it ", ele.route);
      }
    });

    // //console.log(
    //   "path name location  ",
    //   location.pathname.split("/")[location.pathname.split("/").length - 1],
    // );
    if (
      location.pathname.split("/")[location.pathname.split("/").length - 1] ==
      "countersale"
    ) {
      dispatch(setBarSide(true));
      // //console.log(
      //   "path name location true ",
      //   location.pathname.split("/")[location.pathname.split("/").length - 1],
      // );
    } else {
      // //console.log(
      //   "path name location else ",
      //   location.pathname.split("/")[location.pathname.split("/").length - 1],
      // );
      // dispatch(setBarSide(false));
    }
  }, [location.pathname, userDetail, changeRoll]);

  const token = sessionStorage.getItem("smbToken");
  useEffect(() => {
    if (token && !userDetail?.appMenu) {
      getUser();
    }

  }, [token]);



  useEffect(() => {
    let val = sideBarRenderHandler(location.pathname);
    // //console.log("valvalval ", val);
    // dispatch(setbusinessChooseTab())
    getToken();
    dispatch(setBarName(val));
  }, [location.pathname]);

  useEffect(() => {
    if (userDetail?.appMenu && changeRoll != "") {
      redirectContinuousPage();
      const key =
        location.pathname.split("/")[location.pathname.split("/").length - 1];
      //  //console.log("checkIsCustomer", checkIsCustomer(key), " ", key);
      if (!checkIsCustomer(key) && !notApplyAuthRouting[key]) {
        navigate(-1);
      }
    }
    // //console.log("userDetailchangeRoll ", changeRoll);
  }, [location.pathname, userDetail, changeRoll]);
  React.useEffect(() => {
    //console.log("changeRoll ", changeRoll);
  }, [changeRoll]);

  useEffect(() => {
    //console.log("favProduct", favProduct);
  }, [favProduct]);

  const [anchorEl, setAnchorEl] = useState(null);
  const breakpoint = useBreakpoint(useTheme, useMediaQuery);
  return (
    <div>
      <Loader />
      <SimpleSnackbar />

      <Grid container spacing={0}>
        <Grid
          item
          sm={12}
          md={12}
          lg={12}
          sx={{
            width: "100%",
            zIndex: "999",

            position: "sticky",
            backgroundColor: "#E3E3FF",
            top: 0,
            display: {
              xs: "block",
            },
          }}
        >
          {(userDetail?.appMenu !== "Biller" ||
            (changeRoll !== "dashboard" && userDetail?.role !== "Admin")) && (
            <>
              <NavBoarContainer
                setNavbarSearchFilterOpen={setNavbarSearchFilterOpen}
                setAnchorEl={setAnchorEl}
              />
              {/* <Menu
                id="navbarFilterSearch"
                aria-labelledby="navbar_search_input"
                anchorReference="anchorPosition"
                anchorPosition={{ top: 100, left: window.innerWidth/1.5 }}
                open={navbarSearchFilterOpen}
                onClose={()=>setNavbarSearchFilterOpen(false)}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <MenuItem onClick={()=>setNavbarSearchFilterOpen(false)}>Profile</MenuItem>
                <MenuItem onClick={()=>setNavbarSearchFilterOpen(false)}>My account</MenuItem>
                <MenuItem onClick={()=>setNavbarSearchFilterOpen(false)}>Logout</MenuItem>
              </Menu> */}
              <SearchFilterModal
                open={navbarSearchFilterOpen}
                setOpen={setNavbarSearchFilterOpen}
              />
            </>
          )}
          {userDetail?.appMenu == "Biller" &&
            (changeRoll === "dashboard" || userDetail?.role === "Admin") && (
              <NavbarDashboard
                setDrawerShowSideBar={(data) => setDrawerShow(data)}
                setsideBarDrawer={setsideBarDrawer}
              />
            )}
        </Grid>
        {(userDetail?.appMenu == "Biller" || userDetail?.role == "Associate") &&
          location.pathname.split("/")[
            location.pathname.split("/").length - 1
          ] != "admin" &&
          location.pathname.split("/")[
            location.pathname.split("/").length - 1
          ] != "advertisementTools" &&
          location.pathname.split("/")[
            location.pathname.split("/").length - 1
          ] != "rechargeTools" &&
          location.pathname.split("/")[
            location.pathname.split("/").length - 1
          ] != "supportTools" &&
          (changeRoll === "dashboard" || userDetail?.role == "Associate") &&
          (barName == "analatic" ||
            barName == "bussinessMangment" ||
            barName == "CustomerMangment" ||
            barName == "billing" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "bulkMessage" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "bulkMessage" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "shareMessage" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "shareratecart" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "sharemessagecontainer" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "shareEmployeeProfile" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "employeeadvancepaymentreport" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "employeepayrollreport" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "employeedetailreport" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "customerinforeport" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "customerhistoryreport" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "customerappointmentreport" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "myprofile" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "reset-mpin" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "account-recharge" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "printerSetting" ||
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] == "enquiries") && (
            <Grid
              item
              sm={2}
              md={2}
              lg={2}
              sx={{
                width: "100%",
                zIndex: "1",
                position: "sticky",
                top: 0,
                display: {
                  xs: "none",
                  sm: "block",
                },
              }}
            >
              {breakpoint == "xs" ? (
                <Drawer
                  sx={{ "& .MuiPaper-root": { top: "50px", width: "100%" } }}
                  anchor={"right"}
                  open={sideBarDrawer}
                  onClose={() => {
                    setsideBarDrawer(false);
                  }}
                  onClick={() => setsideBarDrawer(false)}
                >
                  {" "}
                  <AnalaticSideBarT breakpoint={breakpoint} />
                </Drawer>
              ) : (
                <AnalaticSideBarT />
              )}
              {/* {<AnalaticSideBarT />}
              {/* {location.pathname !=="/home" &&  <AnalaticSideBarT />} */}

              {/* <Analatic/>
          {barName=="bussinessMangment"  && (
            <BussinessMangment menuLoginHeader={menuLoginHeader} />
          )}
          { barName=="CustomerMangment"  && (
            <CustomerMangementbar menuLoginHeader={menuLoginHeader} />
          )}
          { barName=="analatic" && <Analatic />}
          {barName=="billing"  && (
            <BillingBarSide menuLoginHeader={menuLoginHeader} />
          )} */}
            </Grid>
          )}
        {userDetail?.role === "Admin" && (
          <Grid
            item
            sm={2}
            md={2}
            lg={2}
            sx={{
              width: "100%",
              zIndex: "1",
              position: "sticky",
              top: 0,
              display: {
                xs: "block",
              },
            }}
          >
            {/* <h1>Helloooooooooooooooo</h1> */}
            {/* {<AnalaticSideBarT />} */}
            {breakpoint == "xs" ? (
              <Drawer
                sx={{ "& .MuiPaper-root": { top: "50px", width: "100%" } }}
                anchor={"right"}
                open={sideBarDrawer}
                onClose={() => {
                  setsideBarDrawer(false);
                }}
                onClick={() => setsideBarDrawer(false)}
              >
                {" "}
                <AdminSidebar />
              </Drawer>
            ) : (
              <AdminSidebar />
            )}
            {/* {location.pathname !=="/home" &&  <AnalaticSideBarT />} */}

            {/* <Analatic/> */}
            {/* {barName=="bussinessMangment"  && (
                <BussinessMangment menuLoginHeader={menuLoginHeader} />
              )}
              { barName=="CustomerMangment"  && (
                <CustomerMangementbar menuLoginHeader={menuLoginHeader} />
              )}
              { barName=="analatic" && <Analatic />}
              {barName=="billing"  && (
                <BillingBarSide menuLoginHeader={menuLoginHeader} />
              )} */}
          </Grid>
        )}
        <Grid
          item
          sx={{
            height: "100vh",
          }}
          xs={
            halfSideBarRenderingAccordingToPages(location, routePath) &&
            breakpoint != "xs"
              ? 10
              : 12
          }
        >
          <Routes>
            <Route path="/" element={<LandingPage />} />

            {RoutesSet.map((item, index) => {
              return <Route path={item.routePath} element={item.component} />;
            })}
          </Routes>
        </Grid>
        <Grid
          xs={
            location.pathname.split("/")[
              location.pathname.split("/").length - 1
            ] != "admin" &&
            userDetail?.appMenu == "Biller" &&
            (changeRoll === "dashboard" || changeRoll === "admin")
              ? // &&

                // (barName == "analatic" ||
                //   barName == "bussinessMangment" ||
                //   barName == "CustomerMangment" ||
                //   barName == "billing" ||
                //   barName == "adverticement" ||
                //   barName == "UserProfile" ||
                //   barName == "Recharge" ||
                //   barName == "Support"
                // )
                10
              : 12
          }
        >
          <Grid container spacing={0}>
            {/* <Grid
        item
        sm={0.5}
        sx={{
          display: {
            xs: "none",
            sm: halfSideBarRenderingAccordingToPages(location, routePath)
              ? "block"
              : "none",
          },
        }}
        display={
          halfSideBarRenderingAccordingToPages(location, routePath)
            ? "block"
            : "none"
        }
      >
        <HalfSideBar setDrawerShowSideBar={(data) => setDrawerShow(data)} />
      </Grid> */}
            <Grid
              item
              xs={12}
              sx={{
                display: {
                  xs: footerRenderingAccordingToPages(location, routePath)
                    ? "none"
                    : "none",
                  sm: "none",
                },
              }}
            >
              <Footer />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <Drawer
        sx={{ "& .MuiPaper-root": { top: "50px" } }}
        anchor={"right"}
        open={drawerShow}
        onClose={() => {
          setDrawerShow(false);
        }}
        onClick={() => setDrawerShow(false)}
      >
      </Drawer> */}

      <SideBar
        menuOpen={drawerShow}
        anchorEl={anchorEl}
        handleClose={() => {
          setDrawerShow(false);
        }}
        menuLoginHeader={menuLoginHeader}
        setHelpOpen={setHelpOpen}
        setShareOpen={setShareOpen}
      />
      <HelpModal open={helpOpen} handleClose={() => setHelpOpen(false)} />
      <ShareElegantModal
        open={shareOpen}
        handleClose={() => setShareOpen(false)}
      />

      {footerRenderingAccordingToPages(location, routePath) === false && (
        <Fab
          // color="red"
          sx={{
            position: "fixed",
            bottom: "30px",
            right: { sm: "40px", xs: "20px" },
            backgroundColor: "#25D366 !important",
            width: { sm: "70px", xs: "45px" },
            height: { sm: "70px", xs: "45px" },
          }}
          onClick={() => {
            const whatsappLink = `https://web.whatsapp.com/send?phone=${7721049949}&text=Hello`;
            window.open(whatsappLink, "_blank");
          }}
        >
          <WhatsAppIcon
            sx={{
              color: "white",
              fontSize: { sm: "40px", xs: "30px" },
            }}
          />
        </Fab>
      )}
    </div>
  );
}

export default App;
